<template>
  <div>
    <v-speed-dial bottom direction="top" fixed open-on-hover right>
      <!-- The activator button -->
      <template #activator>
        <v-btn
          @click="buttons[0].action"
          :color="buttons[0].color"
          :dark="!!itemsWithCorrectProperty.length"
          :disabled="!itemsWithCorrectProperty.length"
          fab
          :loading="loadingSaveCorrection"
        >
          <v-tooltip left max-width="600">
            <template #activator="{ on }">
              <v-icon v-on="on">{{ buttons[0].icon }}</v-icon>
            </template>
            <span>{{ buttons[0].tooltip }}</span>
          </v-tooltip>
        </v-btn>
      </template>
      <!-- The rest of the buttons that are shown on hover on the first one -->
      <template v-for="(button, index) in buttons.slice(1)">
        <v-btn
          @click="button.action"
          :color="button.color"
          dark
          :disabled="button.disabled"
          fab
          :key="index"
          small
        >
          <v-tooltip left max-width="600">
            <template #activator="{ on }">
              <v-icon v-on="on">{{ button.icon }}</v-icon>
            </template>
            <span>{{ button.tooltip }}</span>
          </v-tooltip>
        </v-btn>
      </template>
    </v-speed-dial>
    <!-- The dialog to select the classification to move the selected items -->
    <v-classification-selection-dialog
      v-model="showingClassificationSelectionDialog"
    />
    <v-quantity-selection-dialog v-model="showingQuantitySelectionDialog" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} = createNamespacedHelpers("classifier");

import VClassificationSelectionDialog from "./InfiniteItemsSaveButtonClassificationSelectionDialog";
import VQuantitySelectionDialog from "./InfiniteItemsSaveButtonQuantitySelectionDialog";

export default {
  components: {
    VClassificationSelectionDialog,
    VQuantitySelectionDialog,
  },
  data: function () {
    return {
      isOpen: false,
      showingClassificationSelectionDialog: false,
      showingQuantitySelectionDialog: false,
    };
  },
  computed: {
    ...mapGetters(["itemsWithCorrectProperty"]),
    ...mapState(["loadingSaveCorrection"]),
    buttons() {
      return [
        {
          action: this.saveCorrection.bind(null, null),
          color: "light-blue",
          disabled: false,
          icon: "save",
          tooltip: "Guardar QMIs marcados como correctos e incorrectos",
        },
        {
          action: this.setUnmarkedItemsCorrectness.bind(null, true),
          color: "light-green",
          disabled: false,
          icon: "check",
          tooltip: "Marcar todos los no marcados como correctos",
        },
        {
          action: this.setUnmarkedItemsCorrectness.bind(null, false),
          color: "red",
          disabled: false,
          icon: "close",
          tooltip: "Marcar todos los no marcados como incorrectos",
        },
        {
          action: this.setAllItemsCorrectness.bind(null, null),
          color: "grey",
          disabled: false,
          icon: "refresh",
          tooltip: "Desmarcar todos los QMIs",
        },
        {
          action: this.toggleClassificationSelectionDialogVisibility,
          color: "indigo",
          disabled: !this.itemsWithCorrectProperty.filter(
            (item) => item.correct
          ).length,
          icon: "reply",
          tooltip: "Clasificar items seleccionados en otra clasificación",
        },
        {
          action: this.toggleQuantitySelectionDialogVisibility,
          color: "orange",
          disabled: !this.itemsWithCorrectProperty.filter(
            (item) => item.correct
          ).length,
          icon: "auto_awesome_motion",
          tooltip:
            "Especificar la cantidad de productos en las publicaciones seleccionadas",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["saveCorrection"]),
    ...mapMutations(["setAllItemsCorrectness", "setUnmarkedItemsCorrectness"]),
    toggleClassificationSelectionDialogVisibility() {
      this.showingClassificationSelectionDialog = !this
        .showingClassificationSelectionDialog;
    },
    toggleQuantitySelectionDialogVisibility() {
      this.showingQuantitySelectionDialog = !this
        .showingQuantitySelectionDialog;
    },
  },
};
</script>
